import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';
import {Title} from 'shells/typography/title';

import type {
    EditionFragment as Edition,
    SmsEditionFragment as SmsEdition,
} from 'nutshell-graphql-types';

import styles from './edition-sending-state.module.css';

type Props = {
    edition: Edition | SmsEdition;
};

export function EditionSendingState(props: Props) {
    return (
        <div className={styles['edition-sending-state']}>
            <div className={styles['svg-container']}>
                <Illustration src='email-airplane' />
            </div>
            <Title>Off it goes!</Title>
            <Body>{`${props.edition.name} is on its way`}</Body>
            <span>
                Sending may take a few minutes, so come back soon to view engagement metrics.
            </span>
            {/* @ts-expect-error */}
            {props.edition.campaign.__typename === 'Newsletter' ? (
                <Link
                    size='big'
                    // @ts-expect-error
                    as={RoutedLink}
                    variant='button-primary'
                    // @ts-expect-error
                    to={props.edition.campaign.htmlUrlPath}
                >
                    View all editions
                </Link>
            ) : (
                <Link
                    size='big'
                    // @ts-expect-error
                    as={RoutedLink}
                    variant='button-primary'
                    to={`/email-marketing/${
                        props.edition.__typename === 'SmsEdition' ? 'sms/' : ''
                    }broadcasts`}
                >
                    View all broadcasts
                </Link>
            )}
        </div>
    );
}
